import moment from "moment";

export class ObjectHelper {
  static isEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 == null || obj2 == null) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
      if (!keys2.includes(key) || !this.isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  static hasEquivalentData(obj1: any, obj2: any, skipFields: string[] = []): boolean {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 == null || obj2 == null) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    for (const key of keys1) {
      if (!skipFields.includes(key)) {
        if (keys2.includes(key) && !this.isEquivalent(obj1[key], obj2[key])) {
          return false;
        }
      }
    }

    return true;
  }

  static isEquivalent(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;
    if (obj1 == null || obj2 == null) {
      return false;
    }
    if (obj1 instanceof Date) {
      return moment(obj1).isSame(moment(obj2));
    }
    if (typeof obj1 === "object") {
      return this.isEqual(obj1, obj2);
    }

    return obj1 === obj2;
  }

  static isEmpty(obj: any): boolean {
    if (obj === null) return true;
    if (obj === undefined) return true;

    if (typeof obj === "object") {
      return Object.keys(obj).length === 0;
    }
    if (typeof obj === "string") {
      return obj.trim().length === 0;
    }
    return false;
  }
}
